/**
 * Teclado numérico on-screen para entrada de respostas em mobile.
 * Em desktop o aluno usa o teclado físico; o on-screen fica visível como atalho.
 */

export interface KeypadOptions {
  onDigit(digit: string): void;
  onBackspace(): void;
  onEnter(): void;
}

export function mountKeypad(parent: HTMLElement, opts: KeypadOptions): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'keypad';
  const layout: Array<{ label: string; action: 'digit' | 'back' | 'enter'; value?: string; cls?: string }> = [
    { label: '1', action: 'digit', value: '1' },
    { label: '2', action: 'digit', value: '2' },
    { label: '3', action: 'digit', value: '3' },
    { label: '4', action: 'digit', value: '4' },
    { label: '5', action: 'digit', value: '5' },
    { label: '6', action: 'digit', value: '6' },
    { label: '7', action: 'digit', value: '7' },
    { label: '8', action: 'digit', value: '8' },
    { label: '9', action: 'digit', value: '9' },
    { label: '⌫', action: 'back', cls: 'keypad__key--back' },
    { label: '0', action: 'digit', value: '0' },
    { label: '✓', action: 'enter', cls: 'keypad__key--enter' },
  ];
  for (const k of layout) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `keypad__key ${k.cls ?? ''}`;
    btn.textContent = k.label;
    btn.addEventListener('click', () => {
      if (k.action === 'digit' && k.value) opts.onDigit(k.value);
      else if (k.action === 'back') opts.onBackspace();
      else if (k.action === 'enter') opts.onEnter();
    });
    wrap.appendChild(btn);
  }
  parent.appendChild(wrap);
  return wrap;
}
